import { View, Text, Pressable, ActivityIndicator } from 'react-native';
import { monkeyWorldsViewStyles as styles } from './MonkeyWorldsView.styles';
import { MONKEY_WORLDS_ACCENT, MONKEY_WORLDS_TEST_IDS } from '../../../src/quiz/constants/monkeyWorlds.constants';

interface MonkeyWorldsOverlaysProps {
  status: 'loading' | 'ready' | 'error';
  onRetry: () => void;
}

/**
 * The host-side overlay layer: loading until the runtime posts `ready`, error + Retry on
 * `load-error`. Everything else (world map, HUD, clear/failed/world-complete screens) is drawn
 * by the game's canvas itself.
 */
export function MonkeyWorldsOverlays({ status, onRetry }: MonkeyWorldsOverlaysProps) {
  if (status === 'loading') {
    return (
      <View style={styles.overlay} testID={MONKEY_WORLDS_TEST_IDS.loading} pointerEvents="none">
        <ActivityIndicator color={MONKEY_WORLDS_ACCENT} />
      </View>
    );
  }
  if (status === 'error') {
    return (
      <View style={styles.overlay} testID={MONKEY_WORLDS_TEST_IDS.error}>
        <Text style={styles.message}>Could not load the game</Text>
        <Pressable
          testID={MONKEY_WORLDS_TEST_IDS.retry}
          onPress={onRetry}
          style={({ pressed }) => [styles.retryButton, pressed && styles.pressedDim]}
        >
          <Text style={styles.retryText}>Retry</Text>
        </Pressable>
      </View>
    );
  }
  return null;
}
